import { ActionContext, Module } from "vuex";
import { State } from "@/store";
import {
  ImprovementFormState,
  SendFormParameters,
} from "@/improvementForms/types";
import axios from "axios";
import { getOptional } from "@/utils";

export const store: Module<ImprovementFormState, State> = {
  namespaced: true,
  actions: {
    sendForm(
      context: ActionContext<ImprovementFormState, State>,
      {
        content,
        file,
        type,
        objectId,
        url,
        email,
        emailConsent,
      }: SendFormParameters
    ) {
      return new Promise((resolve) => {
        const data = new FormData();
        const selectedCar = context.rootGetters["cars/getSelectedCar"];
        if (selectedCar) {
          data.set(
            "type_id",
            context.rootGetters["cars/getSelectedCar"].typeId
          );
          data.set("vin", context.rootGetters["cars/getSelectedCar"].vin);
        }
        data.set("content", content);
        data.set("_type", type);
        data.set("object_id", objectId || "");
        data.set("source_url", url);
        data.set("emailConsent", emailConsent ? "true" : "false");
        if (file) {
          data.set("file", file);
        }
        if (email) {
          data.set("email", email);
        }
        const headers = {
          "X-CSRFToken": context.rootGetters["accounts/csrf"],
          "Content-Type": "multipart/form-data",
        };
        axios
          .post("/api/forms/form/", data, { headers })
          .then(() => {
            resolve({ isSuccess: true });
          })
          .catch((reason) => {
            resolve({
              isSuccess: false,
              errors: {
                content: getOptional(reason.response.data.content, 0),
              },
            });
          });
      });
    },
  },
};
